Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-my-configurations'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    var $informationWrapper = $('.information-container', $wrapper);
    var $gridWrapper = $('.grid-container', $wrapper);
    var $gridInventory = $('.grid-inventory', $gridWrapper);
    var $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);

    var datasourceInventory;
    var datasourceMyNetwork;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("MyConfigurations", model);
        wrapper.bind(html);
        wrapper.loading(false);
    };

    wrapper.updateGridInventory = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };
    wrapper.updateGridMyNetwork = function () {
        wrapper.loading(true);
        
        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
        $informationWrapper = $('.information-container', $wrapper);
        $gridWrapper = $('.grid-container', $wrapper);
        $gridInventory = $('.grid-inventory', $gridWrapper);
        $gridMyNetwork = $('.grid-mynetwork', $gridWrapper);
        initTabPanel($wrapper);

        $informationWrapper.on('click', '.confirm-inventory-status .js-submit-button', function (e) {
            wrapper.loading(true);

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.MyConfigurations.Messages.ConfirmInventory());
        });  
    };

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.ConfirmInventorySuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.MyConfigurations.Messages.GetModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.ConfirmInventoryFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
  
    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.data;
        wrapper.update();

        if ($gridInventory.length > 0) {
            datasourceInventory = new kendo.data.DataSource({
                data: model.Items,
                pageSize: 10,
                sort: [{ field: "CanDelete", dir: "desc" }, { field: "FriendlyName", dir: "asc" }]
            });
            $gridInventory.kendoGrid({
                dataSource: datasourceInventory,
                sortable: true,
                filterable: {
                    mode: "row"
                },
                filter: function (e) {
                    console.log(e);
                    if (e.filter == null) {
                        $('.clear-filters', $gridInventory).addClass("hidden");
                    } else {
                        $('.clear-filters', $gridInventory).removeClass("hidden");
                    }
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    buttonCount: 5
                },
                columns: [
                    { field: "FriendlyName", title: model.Literals.FriendlyName },
                    { field: "Name", title: model.Literals.Name },
                    {   
                        dataItem: this,
                        headerTemplate: "<a href='javascript:void(0)' class='clear-filters hidden'><span class='btn-title'>" + model.Literals.ClearFilters + "</span><span class='icon icon-exit'></span></a>",
                        command: [
                            {
                                template: "<a class='btn btn-primary k-grid-btnDelete hidden'><span class='btn-title'>" + model.Literals.Delete + "</span><span class='icon icon-bin'></span></a>",
                                //text: "<span class='btn-title'>" + model.Literals.Delete + "</span><span class='icon icon-bin'></span>",
                                className: "",
                                name: "btnDelete",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    if ( !data.CanDelete) {
                                        kendo.alert("Invalid Action");
                                        return;
                                    }
                                    var $confirmation = $(".x-confirmation-popup.remove", $gridWrapper);
                                    var subtitle = $(".subtitle", $confirmation).text() || "";
                                    $(".subtitle", $confirmation).text(subtitle.replace("{0}", data.FriendlyName || ""));
                                    $.fancybox.open($confirmation, {
                                        'modal': true,
                                        maxWidth: 900,
                                        padding: 0,
                                        closeClick: false,
                                        beforeShow: function () {
                                            $(".cancel", $confirmation).unbind('click').click(function () {
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.Id, "{0}"));
                                            });
                                            jQuery(".js-delete-btn", $confirmation).unbind('click').click(function () {
                                                wrapper.loading(true);
                                                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.MyConfigurations.Messages.Remove(data.Id));
                                                $.fancybox.close();
                                                $(".subtitle", $confirmation).text(subtitle.replace(data.Id, "{0}"));
                                            });
                                        }
                                    });
                                }
                            },
                            {
                                template: "<a href='javascript:void(0)'style='margin-left:6px;' class='btn btn-primary k-grid-btnOpenUrl'><span class='btn-title'>" + model.Literals.Url + "</span><span class='icon icon-arrow-up'></span></a>",
                                className: "",
                                name: "btnOpenUrl",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);

                                    var openUrl = window.open(data.Url, '_blank')
                                }
                            },
                            {
                                template: "<a href='javascript:void(0)'style='margin-left:6px;' class='btn btn-primary k-grid-btnCopyUrl'><span class='btn-title'>" + model.Literals.CopyText + "</span><span class='icon icon-attach'></span></a>",
                                className: "",
                                name: "btnCopyUrl",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);
                                    var url = data.Url;
    
                                    var $temp = $("<input>");
                                    $("body").append($temp);
                                    $temp.val(url).select();
                                    document.execCommand("copy");
                                    $temp.remove();
                                    alert("Url Copied To Clipboard");
                                }
                            },
                            {
                                template: "<div class=''><a href='javascript:void(0)'style='margin-left:6px;' class='btn btn-primary k-grid-btnShareUrl '><span class='btn-title'>" + model.Literals.ShareText + "</span><span class='icon icon-share'></span></a></div>",
                                className: "",
                                name: "btnShareUrl",
                                dataItem: this,
                                click: function (e) {
                                    e.preventDefault();

                                    var tr = $(e.target).closest("tr");
                                    var data = this.dataItem(tr);
                                    var url = data.Url;

                                    if (typeof addthis !== 'undefined') {
                                        addthis.init();
                                    }
                                    addthis.update('share', 'url', url);
                                    addthis.url = url;
                                    addthis.toolbox(".addthis_sharing_toolbox");
                                    $('.addthis_button_compact').trigger('click');
                                }
                            }
                        ]
                    },                 
                ],
                dataBound: function (e) {
                                        
                    var data = this.dataSource.view();

                    for (var i = 0; i < data.length; i++) {
                        var dataItem = data[i];
                        var $tr = $gridInventory.find("[data-uid='" + dataItem.uid + "']");
                       
                        if (!dataItem.CanDelete) {
                            $('.k-grid-btnDelete', $tr).prop('disabled', 'disabled').addClass('disabled').addClass("hidden");
                        } else {
                            $('.k-grid-btnDelete', $tr).prop('disabled', '').removeClass('disabled').removeClass('hidden');
                        }
                    }
                }
            });
            $('.clear-filters', $gridInventory).on("click", function () {
                datasourceInventory.filter({});
                datasourceInventory.sort([{ field: "CanDelete", dir: "desc" }, { field: "ModelNumber", dir: "asc" }]);
                $gridInventory.data("kendoGrid").setDataSource(datasourceInventory);
                $('.clear-filters', $gridInventory).addClass("hidden");
            });
        }

    });


    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.GetModelFailed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
    
    Vendd.MessageBus.publishAsync(wrapper, new Vendd.MyConfigurations.Messages.GetModel());

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.RemoveSuccess, wrapper, function (envelope) {
        if ($gridInventory.length > 0) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.MyConfigurations.Messages.GetModel());
        }
        //wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.RemoveFailed, wrapper, function (envelope) {
        alert("Cannot find Vin Number");
        wrapper.loading(false);
    });

});
